export const isPartnerRole = (userRole) => {
  return userRole === "partner" || userRole === "test-partner";
};

export const isReadOnlyAccount = (userRole) => {
  return userRole === "test-partner";
};

export const getAccountTypeLabel = (userRole) => {
  const labels = {
    "partner": "Partner",
    "test-partner": "Test Partner (Read-Only)",
    "partner-support": "Partner Support",
    "admin": "Administrator",
  };
  
  return labels[userRole] || "User";
};

